import React from 'react';
import { FileEdit, Eye, CheckCircle } from 'lucide-react';

const PolicyStatusBadge = ({ status }) => {
  if (status === 'approved') {
    return (
      <div className="flex items-center gap-1.5 px-2 py-1 bg-green-50 border border-green-200 rounded text-xs">
        <CheckCircle className="w-3.5 h-3.5 text-green-600" />
        <span className="font-medium text-green-700">Approved</span>
      </div>
    );
  }

  if (status === 'review') {
    return (
      <div className="flex items-center gap-1.5 px-2 py-1 bg-blue-50 border border-blue-200 rounded text-xs">
        <Eye className="w-3.5 h-3.5 text-blue-600" />
        <span className="font-medium text-blue-700">In Review</span>
      </div>
    );
  }

  // Default: draft
  return (
    <div className="flex items-center gap-1.5 px-2 py-1 bg-amber-50 border border-amber-200 rounded text-xs">
      <FileEdit className="w-3.5 h-3.5 text-amber-600" />
      <span className="font-medium text-amber-700">Draft</span>
    </div>
  );
};

export default PolicyStatusBadge;
